import { render } from "./manage-dependents.vue?vue&type=template&id=4eadecd0&scoped=true"
import script from "./manage-dependents.vue?vue&type=script&lang=js"
export * from "./manage-dependents.vue?vue&type=script&lang=js"

import "./manage-dependents.vue?vue&type=style&index=0&id=4eadecd0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eadecd0"]])

export default __exports__